var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoReq = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 39.674,
  height: 42.25,
  viewBox: "0 0 39.674 42.25",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2081",
  "data-name": "Rectangle 2081",
  width: 15,
  height: 15,
  transform: "translate(-24.576 26)",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 1
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "noun_Wait_for_File_322290",
  "data-name": "noun_Wait for File_322290",
  transform: "translate(0.25 0.25)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_394",
  "data-name": "Group 394"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_240",
  "data-name": "Path 240",
  d: "M28.752,22.695A.7.7,0,0,0,28.058,22H10.695a.695.695,0,1,0,0,1.389H28.058A.7.7,0,0,0,28.752,22.695Z",
  transform: "translate(-3.055 -6.72)",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_241",
  "data-name": "Path 241",
  d: "M10.695,15.389H17.64a.695.695,0,0,0,0-1.389H10.695a.695.695,0,0,0,0,1.389Z",
  transform: "translate(-3.055 -4.277)",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_242",
  "data-name": "Path 242",
  d: "M23.891,30h-13.2a.695.695,0,1,0,0,1.389h13.2a.695.695,0,1,0,0-1.389Z",
  transform: "translate(-3.055 -9.164)",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_243",
  "data-name": "Path 243",
  d: "M24.585,38.695A.7.7,0,0,0,23.891,38h-13.2a.695.695,0,0,0,0,1.389h13.2A.7.7,0,0,0,24.585,38.695Z",
  transform: "translate(-3.055 -11.608)",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_244",
  "data-name": "Path 244",
  d: "M10.695,46a.695.695,0,1,0,0,1.389H21.807a.695.695,0,0,0,0-1.389Z",
  transform: "translate(-3.055 -14.052)",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_245",
  "data-name": "Path 245",
  d: "M1.389,1.389H21.53v9.723h9.723V22.919h1.389V10.133L22.51,0H0V41.672H23.614V40.283H1.389Zm21.53.979,7.355,7.355H22.919Z",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_66",
  "data-name": "Mask Group 66",
  transform: "translate(49 1)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "comment",
  transform: "translate(-24.576 26.6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1045",
  "data-name": "Path 1045",
  d: "M12.938-.033H2.062A2.064,2.064,0,0,0,0,2.029V8.685a2.065,2.065,0,0,0,2.055,2.062v3.02l4.34-3.02h6.542A2.065,2.065,0,0,0,15,8.685V2.029A2.064,2.064,0,0,0,12.938-.033Zm1.183,8.718a1.185,1.185,0,0,1-1.183,1.183H6.12L2.934,12.085V9.868H2.062A1.185,1.185,0,0,1,.879,8.685V2.029A1.185,1.185,0,0,1,2.062.846H12.938a1.185,1.185,0,0,1,1.183,1.183Zm0,0",
  transform: "translate(0 0.033)",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 0.025
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1046",
  "data-name": "Path 1046",
  d: "M4.282,3.279h6.971v.879H4.282Zm0,0",
  transform: "translate(-0.268 -0.174)",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 0.025
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1047",
  "data-name": "Path 1047",
  d: "M4.282,5.279h6.971v.879H4.282Zm0,0",
  transform: "translate(-0.268 -0.299)",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 0.025
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1048",
  "data-name": "Path 1048",
  d: "M4.282,7.279h6.971v.879H4.282Zm0,0",
  transform: "translate(-0.268 -0.424)",
  fill: "#0072ce",
  stroke: "#0072ce",
  strokeWidth: 0.025
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoReq);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/infoReq.e712dbcf1b346861fe6f3a215e3f8d1d.svg";